module.exports = __webpack_public_path__ + "static/iatf-a726d21f95b4673f8074053b56a5b488.jpg";